<template>
  <div container>
    <div grid="row wrap" column="12">
      <div v-html="personal_header_html"></div>
    </div>
    <iframe
      :height="iframeHeight"
      :src="value.personalInfoValues.iframeUrl"
      :width="iframeWidth"
      frameborder="0"
      ref="frame"/>
    <div>
      <hr class="_mbxs _mts">
    </div>
  </div>
</template>

<script>
  import clientOnboardVerbiage from '@mixins/clientOnboardVerbiage'

  export default {
    name: 'Personal',
    props: {
      value: {
        type: Object
      }
    },
    data() {
      return {
        iframeWidth: '100%',
        iframeHeight: '750'
      }
    },
    mixins: [clientOnboardVerbiage],
    mounted() {
      setTimeout(() => document.getElementById('PersonalTitle').scrollIntoView(), 100)
    }
  }
</script>
